export class AppOrganizationPortalContext {
  OrganizationId: string;
  OrganizationName: string;
  OAuthRelayDomain: string;
  Domain: string;
  PortalId: string;
  AllowLocalLogin: boolean;
  IdentityProviders: { Id: string; Name: string }[];
  LoginLogoUrl?: string;
  CustomDomainContentBaseUrl: string;
}

export class Actor {
  Type: string;
  Id: string;
  FirstName?: string;
  LastName?: string;
  EmailAddress?: string;
}
